"use client";

import { Core } from "@faire/design-tokens";
import { useIsEligibleForMobileLoggedOutNavWithCartSignUp } from "@faire/retailer-visitor-shared/components/Header/__internal__/useIsEligibleForMobileLoggedOutNavWithCartSignUp";
import { useNavigateAndHideMenu } from "@faire/retailer-visitor-shared/components/Header/mobile/Navigation/useNavigateAndHideMenu";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { CartEmpty } from "@faire/slate/icons/CartEmpty";
import { getCurrentPath } from "@faire/web/common/Path";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { Button } from "@faire/web/slate/Button";
import React from "react";

export const HeaderMobileSignUp: React.FC = () => {
  const isSSR = useIsSSR();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isEligibleForMobileLoggedOutNavWithCartSignUp =
    useIsEligibleForMobileLoggedOutNavWithCartSignUp();

  const getLinkTo = (signUpType: SignUpType) => {
    if (isSSR) {
      return getCurrentPath()
        .replace({
          signUp: signUpType,
        })
        .toString();
    }
    return undefined;
  };

  if (isLoggedInRetailer || !isEligibleForMobileLoggedOutNavWithCartSignUp) {
    return null;
  }

  return <ShoppingCartIconButton linkTo={getLinkTo(SignUpType.NAV_CART)} />;
};

const ShoppingCartIconButton = ({ linkTo }: { linkTo: string | undefined }) => {
  const { navigateToSignUp } = useNavigateAndHideMenu();
  return (
    <Button
      variant="tertiary"
      onClick={() =>
        navigateToSignUp(
          undefined,
          {
            sourceId: "mobile_side_catnav_signup_shopping_cart_icon",
          },
          SignUpType.NAV_CART
        )
      }
      linkTo={linkTo}
      data-test-id="signUpShoppingCartIcon"
    >
      <CartEmpty
        margin="0 20px 0 0"
        color={Core.icon.default}
        height="20px"
        width="20px"
      />
    </Button>
  );
};
